module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    staticClass: "login-content"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-middle"
  }, [_c('div', {
    staticClass: "text-center text-center"
  }, [_c('h1', {
    staticClass: "error-number mb-2"
  }, [_vm._v("404")]), _vm._v(" "), _c('h2', {
    staticClass: "mb-2"
  }, [_vm._v("Sorry but we couldn't find this page")]), _vm._v(" "), _c('p', [_vm._v("This page you are looking for does not exist")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mid_center"
  }, [_c('h3', {
    staticClass: "mt-5"
  }, [_vm._v("Search")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "col-xs-12 form-group pull-right top_search"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search for..."
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue",
      "dark": ""
    }
  }, [_vm._v("Go!")])], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "login-bottom"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('small', [_vm._v(_vm._s(_vm.copyright))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-5"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Report this?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo02.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-022439c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Page404.vue
// module id = 1903
// module chunks = 0